import { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { formatWelcomeDate } from '@/lib/format'

export function WelcomeSection() {
  const { t, i18n } = useTranslation('dashboard')
  const welcomeDate = useMemo(
    () => formatWelcomeDate(i18n.language),
    [i18n.language]
  )

  return (
    <section
      className='flex min-h-25.25 items-center overflow-hidden rounded-[20px] border border-[#e7e9ef] bg-[linear-gradient(90deg,#fff_0%,#fffcfa_30%,#fff8f4_65%,#fff3ec_100%)] p-6 shadow-[0_1px_8px_-1px_rgba(38,45,66,0.1),0_1px_4px_-1px_rgba(38,45,66,0.05)]'
      aria-labelledby='dashboard-welcome-heading'
    >
      <div className='flex flex-col gap-1'>
        <h1
          id='dashboard-welcome-heading'
          className='font-heading text-xl font-bold leading-[1.2] tracking-[-0.48px] text-[#171a20]'
        >
          {t('welcome.greeting')}
        </h1>
        <p className='font-sans text-xs font-medium leading-[1.4] text-[#6c7285]'>
          {welcomeDate}
        </p>
      </div>
    </section>
  )
}
